module.exports = __webpack_public_path__ + "13dd9fd3af73159dc3f958be5f4e722e.jpg";